<!-- wrapper optionnel -->
<div [class.graph-card]="!bare" [class.updating]="updating()" *ngIf="!loading(); else loadingTpl" style="transition: opacity 0.2s ease-in-out;" (click)="closeTooltip(); closeSensorTooltip()">
  <div class="header" *ngIf="!bare">
    <h3>{{ 'previsions.forecastGraph.title' | translate }}</h3>
  </div>

  <ng-container *ngIf="queueId; else noQueueTpl">
    <div *ngIf="isEstablishmentClosed(); else openChartTpl" class="closed-establishment">
      <div class="closed-message">
        <span>🔒</span>
        <h3>{{ 'previsions.forecastGraph.closedEstablishment.title' | translate }}</h3>
        <p>{{ 'previsions.forecastGraph.closedEstablishment.subtitle' | translate }}</p>
      </div>
    </div>
    
    <ng-template #openChartTpl>
      <div class="chart" [style.opacity]="updating() ? 0.6 : 1" style="transition: opacity 0.2s ease-in-out;">
        <div class="plot">
        <svg
          [attr.viewBox]="'0 0 ' + W + ' ' + H"
          preserveAspectRatio="none"
          role="img"
          [attr.aria-label]="'previsions.forecastGraph.ariaLabel' | translate">

          <!-- Grille horizontale -->
          <g>
            <line *ngFor="let y of yTicks"
                  x1="0" [attr.x2]="W"
                  [attr.y1]="yToPx(y)" [attr.y2]="yToPx(y)"
                  stroke="#e5e7eb" stroke-width="1" />
          </g>

          <!-- Barres (32 créneaux de 30min) : seulement si ouvert -->
          <g *ngIf="timeSlotData.length; else emptySvgTpl">
            <ng-container *ngFor="let p of timeSlotData; let i = index">
              <rect
                [attr.x]="i * colW + gap/2"
                [attr.width]="colW - gap"
                [attr.y]="yToPx(p.minutes)"
                [attr.height]="H - axisH - yToPx(p.minutes)"
                rx="3"
                [attr.fill]="color(p.minutes)"
                [attr.class]="getBarClass(i, p)">
              </rect>
              <!-- Valeur sur la barre -->
              <text *ngIf="showValues && p.minutes > 1"
                    [attr.x]="i * colW + colW/2"
                    [attr.y]="yToPx(p.minutes) - 4"
                    text-anchor="middle" font-size="11" font-weight="600" fill="#374151">
                {{ p.minutes }}
              </text>
            </ng-container>
          </g>

          <!-- Courbe baseline pointillée -->
          <path 
            *ngIf="baselineSlotData.length > 0 && displayBaseline"
            [attr.d]="getBaselinePath()"
            fill="none"
            stroke="#FF2B98"
            stroke-width="3"
            stroke-dasharray="8,4"
            stroke-linecap="round"
            opacity="0.9">
          </path>

          <!-- Courbe scans historiques (échelle dédiée getHistoricalScanY, indépendante des minutes) -->
          <path 
            *ngIf="showHistoricalScans"
            [attr.d]="getHistoricalScansPath()"
            fill="none"
            stroke="#3b82f6"
            stroke-width="3"
            stroke-dasharray="8,4"
            stroke-linecap="round"
            opacity="0.9">
          </path>

          <!-- Points sur la courbe scans historiques -->
          <g *ngIf="showHistoricalScans">
            <circle *ngFor="let slot of timeSlots; let i = index"
              [attr.cx]="(i + 0.5) * colW"
              [attr.cy]="getHistoricalScanY(i)"
              r="5"
              fill="#3b82f6"
              stroke="white"
              stroke-width="2.5"
              class="scan-point"
              [class.pinned]="pinnedSlot() === i"
              (mouseenter)="onPointHover(i, $event)"
              (mouseleave)="onPointLeave()"
              (click)="onPointClick(i, $event)">
            </circle>
          </g>

          <!-- Courbe flux capteur (entrées par créneau) -->
          <path
            *ngIf="showSensorFlow && sensorFlowData && sensorFlowData.length > 0"
            [attr.d]="getSensorFlowPath()"
            fill="none"
            stroke="#22c55e"
            stroke-width="3"
            stroke-dasharray="8,4"
            stroke-linecap="round"
            opacity="0.9">
          </path>

          <!-- Points sur la courbe flux capteur -->
          <g *ngIf="showSensorFlow && sensorFlowData && sensorFlowData.length > 0">
            <circle *ngFor="let slot of timeSlots; let i = index"
              [attr.cx]="(i + 0.5) * colW"
              [attr.cy]="getSensorFlowY(i)"
              r="4"
              fill="#22c55e"
              stroke="white"
              stroke-width="2"
              class="sensor-point"
              [class.pinned]="pinnedSensorSlot() === i"
              (mouseenter)="onSensorHover(i, $event)"
              (mouseleave)="onSensorLeave()"
              (click)="onSensorClick(i, $event)">
            </circle>
          </g>

          <!-- Axe X (créneaux 30min, affichage toutes les heures) -->
          <g>
            <ng-container *ngFor="let slot of timeSlots; let i = index">
              <text *ngIf="i % 2 === 0"
                    [attr.x]="i * colW + colW/2"
                    [attr.y]="H - 6"
                    text-anchor="middle" font-size="10" fill="#6b7280">
                {{ slot.hours }}h
              </text>
            </ng-container>
          </g>

          <!-- Axe Y à droite (ticks dynamiques) -->
          <g>
            <text *ngFor="let y of yTicks"
                  [attr.x]="W - 4"
                  [attr.y]="clampTickY(y)"
                  text-anchor="end" font-size="12" fill="#6b7280">
              {{ y }} min
            </text>
          </g>

          <ng-template #emptySvgTpl><g></g></ng-template>
        </svg>
        </div>
      </div>

      <div class="legend" *ngIf="!bare">
        <span><i class="dot" [style.background]="barColorLow"></i> &lt; {{ lowTh() }} min</span>
        <span><i class="dot" [style.background]="barColorMid"></i> {{ lowTh() }}–{{ highTh() }} min</span>
        <span><i class="dot" [style.background]="barColorHigh"></i> &gt; {{ highTh() }} min</span>
        <span *ngIf="baselineSlotData.length > 0" style="color: #FF2B98; font-weight: 600;">
          <span style="display: inline-block; width: 20px; height: 3px; background: repeating-linear-gradient(to right, #FF2B98 0, #FF2B98 8px, transparent 8px, transparent 12px); vertical-align: middle; margin-right: 6px;"></span>
          {{ 'previsions.forecastGraph.legend.baselineReference' | translate }}
        </span>
        <span *ngIf="showSensorFlow && sensorFlowData && sensorFlowData.length > 0" style="color: #22c55e; font-weight: 600;">
          <span style="display: inline-block; width: 20px; height: 3px; background: repeating-linear-gradient(to right, #22c55e 0, #22c55e 8px, transparent 8px, transparent 12px); vertical-align: middle; margin-right: 6px;"></span>
          {{ 'previsions.forecastGraph.legend.sensorFlow' | translate }}
        </span>
      </div>
    </ng-template>
  </ng-container>
</div>

<!-- Tooltip scans historiques -->
<div class="scan-tooltip" *ngIf="hoveredSlot() !== null" [style.left.px]="tooltipX()" [style.top.px]="tooltipY()">
  <div class="tooltip-header">
    <span>{{ getTooltipData(hoveredSlot()!).time }}</span>
    <button type="button" class="tooltip-close" *ngIf="pinnedSlot() !== null" (click)="closeTooltip(); $event.stopPropagation()" [attr.aria-label]="'previsions.forecastGraph.tooltip.close' | translate">&times;</button>
  </div>
  <div class="tooltip-body">
    <div class="tooltip-row real">
      <span class="tooltip-label">{{ 'previsions.forecastGraph.tooltip.queueLabel' | translate }}</span>
      <span class="tooltip-value">{{ getTooltipData(hoveredSlot()!).queueName }}</span>
    </div>
    <div class="tooltip-row real">
      <span class="tooltip-label">{{ 'previsions.forecastGraph.tooltip.contextLabel' | translate }}</span>
      <span class="tooltip-value">{{ getTooltipData(hoveredSlot()!).context }}</span>
    </div>
    <div class="tooltip-row real" *ngIf="getTooltipData(hoveredSlot()!).periods.length > 0">
      <span class="tooltip-label">{{ 'previsions.forecastGraph.tooltip.periodsLabel' | translate }}</span>
      <div class="tooltip-periods">
        <div class="tooltip-period-item" *ngFor="let period of getTooltipData(hoveredSlot()!).periods">
          <span class="period-name">{{ period.name }}</span>
          <span class="period-dates" *ngIf="period.endDate">
            {{ 'previsions.forecastGraph.tooltip.periodRange' | translate:{ start: period.startDate, end: period.endDate } }}
          </span>
          <span class="period-dates" *ngIf="!period.endDate">
            {{ 'previsions.forecastGraph.tooltip.periodSince' | translate:{ start: period.startDate } }}
          </span>
          <span class="period-scans">{{ 'previsions.forecastGraph.tooltip.periodAvgScans' | translate }} <strong>{{ period.avgScans | number:'1.1-1' }}</strong></span>
        </div>
      </div>
    </div>
    <div class="tooltip-row real">
      <span class="tooltip-label">{{ 'previsions.forecastGraph.tooltip.avgScans' | translate }}</span>
      <span class="tooltip-value">{{ getTooltipData(hoveredSlot()!).scansMoyen }}</span>
    </div>
  </div>
</div>

<!-- Tooltip affluence capteur -->
<div class="scan-tooltip" *ngIf="hoveredSensorSlot() !== null" [style.left.px]="sensorTooltipX()" [style.top.px]="sensorTooltipY()">
  <div class="tooltip-header sensor-tooltip-header">
    <span>{{ getSensorTooltipData(hoveredSensorSlot()!).time }}</span>
    <button type="button" class="tooltip-close" *ngIf="pinnedSensorSlot() !== null" (click)="closeSensorTooltip(); $event.stopPropagation()" [attr.aria-label]="'previsions.forecastGraph.tooltip.close' | translate">&times;</button>
  </div>
  <div class="tooltip-body">
    <div class="tooltip-row real">
      <span class="tooltip-label">{{ 'previsions.forecastGraph.tooltip.sensorAvgIn' | translate }}</span>
      <span class="tooltip-value sensor-value">↑ {{ getSensorTooltipData(hoveredSensorSlot()!).avgIn | number:'1.1-1' }}</span>
    </div>
    <div class="tooltip-row real">
      <span class="tooltip-label">{{ 'previsions.forecastGraph.tooltip.sensorAvgOut' | translate }}</span>
      <span class="tooltip-value sensor-value">↓ {{ getSensorTooltipData(hoveredSensorSlot()!).avgOut | number:'1.1-1' }}</span>
    </div>
    <div class="tooltip-row real">
      <span class="tooltip-label">{{ 'previsions.forecastGraph.tooltip.sensorOccupancy' | translate }}</span>
      <span class="tooltip-value sensor-value">≈ {{ getSensorTooltipData(hoveredSensorSlot()!).occ | number:'1.0-0' }} {{ 'previsions.forecastGraph.unit.people' | translate }}</span>
    </div>
    <div class="tooltip-row real">
      <span class="tooltip-label">{{ 'previsions.forecastGraph.tooltip.sensorDataDays' | translate }}</span>
      <span class="tooltip-value">{{ getSensorTooltipData(hoveredSensorSlot()!).occurrenceCount }}</span>
    </div>
  </div>
</div>

<ng-template #noQueueTpl>
  <div class="empty">{{ 'previsions.forecastGraph.noQueue' | translate }}</div>
</ng-template>

<ng-template #loadingTpl>
  <div [class.graph-card]="!bare" class="loading">{{ 'previsions.forecastGraph.loading' | translate }}</div>
</ng-template>
